import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "grid grid-cols-4 gap-x-6 w-9/12 gap-y-6" }
const _hoisted_3 = { class: "mt-1.5" }
const _hoisted_4 = { class: "space-y-2 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Klik tombol di bawah ini untuk mengaktifkan atau menonaktifkan status ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    scrollSidebar: "",
    "custom-class": "px-0 pb-6",
    title: _ctx.$route.meta.name,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[6] || (_cache[6] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage,
    fullPage: "",
    verticalSeparator: false
  }, {
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_lp_button, {
          "text-color": "white",
          customClass: "w-full py-2.5",
          title: "Simpan",
          onClick: _ctx.onSubmit,
          disabled: !_ctx.isFormValid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    data: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Tipe Akun",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.form.ctufAccountType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.ctufAccountType = $event)),
              placeholder: "ID Konfigurasi",
              disabled: "",
              disableBackground: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: "Nama POS",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_MultipleSelectSearch, {
                "modal-title": "Nama POS",
                "option-name": "name",
                onFocus: _ctx.filterPos,
                onFilter: _ctx.filterPos,
                onChange: _ctx.onChangeFilterPos,
                options: _ctx.listPos,
                modelValue: _ctx.searchPartner,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchPartner = $event)),
                keyName: "name",
                keyValue: "id",
                placeholder: "Ketik atau pilih nama pos",
                isLoading: _ctx.isLoadingPartner,
                showReset: "",
                "able-to-delete-in-modal": "",
                customDisplayAll: "Semua POS"
              }, null, 8, ["onFocus", "onFilter", "onChange", "options", "modelValue", "isLoading"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-4",
          label: "Biaya Top Up",
          asterisk: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.form.ctufTopUpFee,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.ctufTopUpFee = $event)),
              prefix: "Rp",
              format: _ctx.formatRupiah,
              onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
              placeholder: "Jumlah biaya top up",
              onChange: _ctx.onChangeTopupFee,
              errorIcon: false,
              error: _ctx.isErrorTopupFee,
              errorCaption: `Minimum biaya top up ${_ctx.minimumValue}. Cek & atur ulang`
            }, null, 8, ["modelValue", "format", "onChange", "error", "errorCaption"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          class: "col-span-4",
          label: "Status Konfigurasi Biaya Top Up"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.isActive,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isActive = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "leave-page-confirmation", "onLeavePage"]))
}